// extracted by mini-css-extract-plugin
export default {"ref":"trip_ref__0KqFr","amount":"trip_amount__tPpEB"};